module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/2_eea072f76b87f2073e91aad1c55bc384.png";